module.exports = __webpack_public_path__ + "img/book-big.cca8953b.svg";